
// import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';

// import "../lib/nice-select2/js/nice-select2";
// import NiceSelect from "nice-select2";
// import "../lib/nice-select2/js/style";